// extracted by mini-css-extract-plugin
export default {"paper":"organisation-area-settings-popover_paper__3pyWO"};